import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logo" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "actions" }

import { ref } from 'vue';
import { generateUrl } from '@nextcloud/router';

import UploadMenuItem from '@components/header/UploadMenuItem.vue';
import SearchbarMenuItem from '@components/header/SearchbarMenuItem.vue';
import XImg from '@components/frame/XImg.vue';

import * as utils from '@services/utils/common';

import banner from '@assets/banner.svg';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileHeader',
  setup(__props) {

const isScrollDown = ref(false);
const homeUrl = generateUrl('/');

utils.useBus('memories.recycler.scroll', ({ current, previous }) => {
  isScrollDown.value = (isScrollDown.value && previous - current < 40) || current - previous > 40; // momentum scroll
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "mobile-header",
    class: _normalizeClass(["timeline-scroller-gap", {
      visible: !isScrollDown.value,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", { href: _unref(homeUrl) }, [
        _createVNode(XImg, {
          src: _unref(banner),
          "svg-tag": true
        }, null, 8, ["src"])
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(UploadMenuItem),
      _createVNode(SearchbarMenuItem)
    ])
  ], 2))
}
}

})